import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const bannerStyle = {
    position: 'fixed',
    bottom: 0,
    width: '100%',
    backgroundColor: 'rgba(99,102,241,0.95)',
    color: '#fff',
    padding: '12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '14px',
    zIndex: 1000
};

const CookieBanner = () => {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        let consent = localStorage.getItem('gonkle_cookie_consent');
        if (!consent) {
            // check cookie fallback
            const match = document.cookie.match(/(^|;)\s*gonkle_cookie_consent=([^;]+)/);
            consent = match ? match[2] : null;
            if (consent && consent === 'accepted') {
                localStorage.setItem('gonkle_cookie_consent','accepted');
            }
        }
        if (consent !== 'accepted') {
            setVisible(true);
        }
    }, []);

    const accept = () => {
        localStorage.setItem('gonkle_cookie_consent', 'accepted');        // set an actual cookie as fallback (1 year)
        document.cookie = "gonkle_cookie_consent=accepted; max-age=" + 60*60*24*365 + "; path=/";        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div style={bannerStyle}>
            <div style={{ flex: 1 }}>{t('cookie_banner_text')}</div>
            <div>
                <button onClick={accept} style={{ marginRight: '8px' }}>{t('cookie_banner_accept')}</button>
                <a href="/datenschutz" style={{ color: '#fff', textDecoration: 'underline' }}>{t('cookie_banner_learn_more')}</a>
            </div>
        </div>
    );
};

export default CookieBanner;
